<template>
  <v-slide-y-reverse-transition>
    <div
      class="viewBox"
      :style="{'background-color':backgroundColor}"
    >
      <v-app-bar
        class="header"
        :color="baseColor"
        dense
        elevation="3"
      >
        <v-btn
          v-if="$store.state.displayDetailView === true && $store.state.detailOrigin === 'search'"
          icon
          @click="$store.commit('closeDetailView');$store.commit('showSearchMenu');"
        >
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
        <v-btn
          v-else
          icon
          @click="$store.commit('closeAllMenus');$store.commit('setDetailViewOrigin', undefined);"
        >
          <v-icon
            :color="iconColor"
          >
            mdi-close
          </v-icon>
        </v-btn>
        <v-toolbar-title
          class="unselectable"
          style="font-size: 1.75em; letter-spacing: 0.05em;"
          :style="{color:iconColor}"
        >
          {{ heading }}
        </v-toolbar-title>
        <v-spacer />
        <v-icon :color="iconColor">
          {{ icon }}
        </v-icon>
      </v-app-bar>
      <v-content
        ref="main"
        class="content scroll"
      >
        <!--content will be passed into slot-->
        <slot />
      </v-content>
    </div>
  </v-slide-y-reverse-transition>
</template>

<script>

export default {
  name: 'ViewBox',
  components: {},
  props: {
    heading: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      baseColor: this.$appConfig.baseColor,
      baseColorAccent: this.$appConfig.baseColorAccent,
      iconColor: this.$appConfig.iconColor,
      backgroundColor: this.$appConfig.backgroundColor,
    };
  },
  methods: {
  },
};

</script>

<style scoped>
/* TODO change .viewBox styling to $mq config */
  .viewBox {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9;
  }
  .scroll {
    overflow-y: scroll;
    /* overflow-y: auto; */
  }

  .header {
    width: 100%;
    position: sticky;
    /* position: fixed; */
    top: 0;
    left: 0;
    z-index: 10;
  }
  .unselectable {
    -webkit-user-select: none; /* Safari */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* IE10+/Edge */
    user-select: none; /* Standard */
  }

  .content {
    width: 100%;
    height: calc(100% - 3em);
    background-color: transparent;
  }

  /* TODO resolve media queries into vue-mq */
  /* |-> Problem: variable in style of class .viewBox */
  @media (min-width: 450px) and (max-width: 1250px) {
    .viewBox {
      width: 38%;
    }
  }

  @media (min-width: 1250px) {
    .viewBox {
      visibility: hidden;
      width: 26%;
    }
  }

</style>
